import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import NavBar from "./components/NavBar";
import About from "./pages/About";
import Projects from "./pages/Projects";
import ProjectDetails from "./pages/ProjectDetails";
import Skills from "./pages/Skills";
import Experience from "./pages/Experience";
import Education from "./pages/Education";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import { LanguageProvider } from "./i18n/LanguageContext";
import PageMetadata from "./i18n/PageMetadata";
require("dotenv").config();

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <NavBar />
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:projectId" element={<ProjectDetails />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/education" element={<Education />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/certificates" element={<Navigate to="/education" replace />} />
            <Route path="/volunteer" element={<Navigate to="/experience" replace />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <PageMetadata />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
